import Dragger from 'antd/lib/upload/Dragger';
import React, { ReactElement, useState } from 'react';
import { ReactComponent as UploadIcon } from '../../../assets/images/svg/i_upload.svg';
import { COMMON_ERROR } from '../../../shared/constants/commonConstants';
import { RECONCILIATION_FILE_TYPES } from '../../../shared/constants/crmConstants';
import { GLOBAL_URL } from '../../../shared/constants/dataServiceUrl';
import { fileUploadBeforeCheck } from '../../../utils/fileUploadUtils';
import { centeredNotification } from '../../../utils/utility';
import './ReconciliationFileUpload.less';
const ReconciliationFileUpload = (props: any): ReactElement => {
  const {   onSuccess = false } = props;
  const [fileList, setFileList] = useState([]);

  const draggerAction = {
    fileList,
    beforeUpload: fileUploadBeforeCheck,
    action: GLOBAL_URL.CRM_BASE_URL + '/Provider/Claim/AddOrUpdateReconciliation',
    withCredentials : true,
    maxCount: 1,
    onChange: (info: any): any => {
      const { file = {}, fileList: fList } = info;
      setFileList(fList);
      if (file?.status === 'done') {
        const { xhr: { response = '{}' } } = file;
        const { isSuccess, errors, errorMessage, totalCount, updatedClaimNumbers = [] } = JSON.parse(response || '{}');
        if (!isSuccess) {
          centeredNotification(errors?.length ? errors.join(',/n') : (errorMessage || COMMON_ERROR));
        } else {
          if (onSuccess) {
            onSuccess(updatedClaimNumbers?.length || 0, totalCount || 0);
          } else {
            centeredNotification(`${updatedClaimNumbers?.length || '0'} / ${totalCount || '0'} claims have been updated in the system. You can view the details in the Timeline.`, 'success');
          }
        }
      }
    },
  };
  return (<>
      <Dragger
        accept={RECONCILIATION_FILE_TYPES.toString()}
        {...draggerAction}
      >
      <p className="text-center">
        <UploadIcon className="fill-primary" /></p>
          <b className="ant-upload-text"> Drag & Drop your file here. </b>
          <p className="ant-upload-hint"> File format needs to be {RECONCILIATION_FILE_TYPES.join(', ')}</p>
      </Dragger>
      {/* <div className="ant-upload-button">
      <Dragger
        accept={RECONCILIATION_FILE_TYPES.toString()}
        {...draggerAction}
      >
    <Button
      type="primary"
      className="w-100"
    >
      Upload
    </Button>
    </Dragger></div> */}
      </>
  );
};
export default ReconciliationFileUpload;
